import React from "react";

const FileCopy = () => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img" 
      aria-label="File Copy"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 4.52801V17.5C16 18.8807 14.8807 20 13.5 20H2.5C1.11929 20 0 18.8807 0 17.5V2.50001C0 1.1193 1.11929 1.13072e-05 2.5 1.13072e-05H11.472C11.6145 -0.00932331 11.754 0.0439954 11.854 0.146011L15.854 4.14601C15.956 4.24598 16.0093 4.38548 16 4.52801ZM11 1.00001H2.5C1.67157 1.00001 1 1.67158 1 2.50001V17.5C1 18.3284 1.67157 19 2.5 19H13.5C14.3284 19 15 18.3284 15 17.5V5.00001H11.5C11.2239 5.00001 11 4.77615 11 4.50001V1.00001ZM12 1.70701V4.00001H14.293L12 1.70701Z"
        fill="white"
      />
    </svg>
  );
};

export default FileCopy;
